const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-2121'; // to be updated

//location form actions
export const resetWirelineTerminateCircuitForm = `RESET-WIRELINE-TERMINATE-CIRCUIT-FORM-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELINE-TERMINATE-CIRCUIT-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELINE-TERMINATE-CIRCUIT-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setRequestSelectedData = `SET-WIRELINE-REQUEST-SELECTED-DATA-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELINE-TERMINATE-SUBSCRIPTION-RESET-LOADING-${actionTypeIdentifier}`;
export const setResetApprover = `SET-WIRELINE-TERMINATE-SUBSCRIPTION-RESET-APPROVER-${actionTypeIdentifier}`;



export const wirelineTerminateCircuitModel = {
    circuitCode: ''
    , circuitId: 0
    , wireLineApproverId: 0

    , localContactEmail: ''
    , localContactFullName: ''
    , localContactPhone: ''

    , altLocalContactEmail: ''
    , altLocalContactFullName: ''
    , altLocalContactPhone: ''

    , terminateDate: ''
    , businessJustification: ''
    , additionalInformation: ''
}
